import { useRouteError } from 'react-router-dom'
import { Button, NoticeText } from '@unimpaired/react'
import {
  faArrowLeft,
  faHome,
  faRefresh,
} from '@fortawesome/free-solid-svg-icons'
import { ApplicationRoutes } from '@unimpaired/utils'
import { getRouteErrorMessage } from './NotFoundPage.helpers'

type Props = {
  goBackPath?: ApplicationRoutes
  goBackText?: string
}

export const NotFoundPage = ({ goBackPath }: Props) => {
  const error = useRouteError()

  return (
    <div className='bg-base-100 text-base-1000 grid px-6 py-24 sm:py-32 lg:px-8 h-screen w-full overflow-hidden'>
      <div className='text-center'>
        <p className='text-base font-semibold'>404</p>
        <h1 className='mt-4 text-3xl font-bold tracking-tight'>
          {getRouteErrorMessage(error)}
        </h1>
        <p className='mt-6 text-base leading-7 text-base-800'>
          There was an issue with your request
        </p>
        <NoticeText
          className='mx-auto mt-4'
          type='info'
          text='Sometimes, a quick refresh is all it takes to fix it :)'>
          <Button
            icon={faRefresh}
            variant='raised'
            onClick={() => {
              window.location.reload()
            }}>
            Refresh
          </Button>
        </NoticeText>
        <div className='mt-10 flex items-center justify-center gap-x-6'>
          <Button to={-1} icon={faArrowLeft}>
            Go Back
          </Button>
          <Button
            // variant='raised'
            icon={faHome}
            to={goBackPath || '/'}>
            Go Home
          </Button>
        </div>
      </div>
    </div>
  )
}
